export const TIME_FORMAT = 'HH:mm';

export enum AnonymityLevel {
  None = 'NONE',
  Organization = 'ORGANIZATION',
}
